import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function AboutMe() {
  const transformations = [{
    from: 'reactivitate',
    to: 'răspunsuri calme și ferme'
  }, {
    from: 'grija copleșitoare',
    to: 'încredere și siguranță'
  }, {
    from: 'conflicte repetate',
    to: 'armonie reală'
  }];
  return <section className="bg-cream py-12 md:py-20 relative overflow-hidden" data-id="element-11">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-12">
        {/* Mobile: Name + Positions centered at top */}
        <div className="lg:hidden text-center mb-8" data-id="element-13">
          <FadeIn data-id="element-14">
            <h2 className="text-[32px] font-medium leading-[1.15] mb-2" data-id="element-15">
              Stela Lucuța
            </h2>
            <p className="font-poppins font-semibold uppercase tracking-[0.15em] text-[13px] text-orange" data-id="element-16">
              Coach . Consultant Comportamental DISC . Trainer . Public Speaker
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-17">
          {/* Left Column: Photo */}
          <div className="lg:col-span-5 relative" data-id="element-18">
            <FadeIn data-id="element-19">
              <div className="relative w-full aspect-[2/3] max-w-[360px] lg:max-w-[450px] mx-auto" data-id="element-20">
                {/* Decorative dots pattern - top left */}
                <svg className="absolute -top-6 -left-6 w-28 h-28 z-0 opacity-25 hidden lg:block" viewBox="0 0 100 100" data-id="element-21">
                  {Array.from({
                  length: 25
                }).map((_, i) => <circle key={i} cx={i % 5 * 22 + 10} cy={Math.floor(i / 5) * 22 + 10} r="2.5" fill="#3D1635" data-id="element-22" />)}
                </svg>

                {/* Plum offset frame */}
                <div className="absolute -bottom-4 -right-4 lg:-bottom-5 lg:-right-5 w-full h-full border-2 border-plum/50 rounded-[24px] z-0" data-id="element-23"></div>

                {/* Corner accent - top right */}
                <div className="absolute -top-3 -right-3 w-16 h-16 border-t-2 border-r-2 border-plum/30 rounded-tr-[16px] z-0 hidden lg:block" data-id="element-24"></div>

                {/* Main Image */}
                <div className="relative z-10 w-full h-full rounded-[24px] overflow-hidden shadow-card-hover border border-plum-border" data-id="element-25">
                  <img src="https://cdn.magicpatterns.com/uploads/eSjLSqoa2bAaocTQv7t32M/Screenshot_(1091).png" alt="Stela Lucuța alături de John C. Maxwell - Maxwell Leadership Certified Team" className="w-full h-full object-cover object-top" data-id="element-26" />
                  {/* Subtle gradient overlay at bottom */}
                  <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-plum/25 to-transparent" data-id="element-27"></div>
                </div>

                {/* Small flame accent - bottom left */}
                <svg className="absolute -bottom-3 -left-4 w-12 h-12 z-20 text-orange opacity-70" viewBox="0 0 100 100" fill="currentColor" data-id="element-28">
                  <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-29" />
                </svg>

                {/* Subtle violet blob */}
                <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-violet/8 rounded-full blur-2xl z-0 hidden lg:block" data-id="element-30"></div>

                {/* Subtle plum blob top */}
                <div className="absolute -top-10 right-10 w-40 h-40 bg-plum/5 rounded-full blur-3xl z-0 hidden lg:block" data-id="element-31"></div>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Text */}
          <div className="lg:col-span-7 max-w-[720px]" data-id="element-32">
            {/* Desktop: Name + Positions */}
            <div className="hidden lg:block" data-id="element-33">
              <FadeIn delay={0.1} data-id="element-34">
                <h2 className="text-[48px] font-medium leading-[1.15] mb-2" data-id="element-35">
                  Stela Lucuța
                </h2>
                <p className="font-poppins font-semibold uppercase tracking-[0.15em] text-[13px] text-orange mb-8" data-id="element-36">
                  Coach . Consultant Comportamental DISC . Trainer . Public
                  Speaker
                </p>
              </FadeIn>
            </div>

            <FadeIn delay={0.2} data-id="element-37">
              <div className="space-y-3 text-[17px] md:text-[19px] leading-[1.65] text-plum-light mb-8" data-id="element-38">
                <p data-id="element-39">
                  Acum 30 de ani am început să-mi pun întrebări despre oameni.
                  De ce unii explodează și alții tac? De ce frații cresc în
                  aceeași casă și ajung atât de diferiți?
                </p>
                <p data-id="element-40">
                  Am studiat Metoda Silva, Școala Ramtha, am devenit coach în
                  Maxwell Leadership Certified Team și Consultant în Analiză
                  Comportamentală folosind metoda DISC. Dar ce mi-a schimbat
                  viața a fost să înțeleg un lucru simplu.
                </p>
                <p className="font-medium text-plum text-xl italic font-fraunces py-2" data-id="element-41">
                  Nu ai nevoie de mai multă voință. Ai nevoie de o ghidare pas
                  cu pas.
                </p>
                <p data-id="element-42">
                  În ultimii 6 ani am ghidat sute de persoane să treacă de la
                  reactivitate și grijă excesivă, la răspunsuri calme, ferme și
                  la relații calde, apropiate, cu cei dragi:
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-43">
              <>
                <div data-id="element-44">
                  <ul className="space-y-3" data-id="element-45">
                    {transformations.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-46">
                        <CheckCircle2 className="w-5 h-5 text-plum shrink-0 mt-0.5" strokeWidth={2} data-id="element-47" />
                        <span className="text-[16px] md:text-[17px] text-plum-light leading-[1.5]" data-id="element-48">
                          De la{' '}
                          <span className="font-medium text-plum" data-id="element-49">
                            {item.from}
                          </span>{' '}
                          la{' '}
                          <span className="font-semibold text-plum" data-id="element-50">
                            {item.to}
                          </span>
                        </span>
                      </li>)}
                  </ul>
                </div>
              </>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}